import React, { useState, useEffect } from 'react';
import { geolocationService } from '../../../engine/utils/geolocation';

interface DebugInfoProps {
    fps: number;
    entityCount: number;
    level: number;
    score: number;
    lives: number;
    isVisible: boolean;
}

const DebugInfo: React.FC<DebugInfoProps> = ({
    fps,
    entityCount,
    level,
    score,
    lives,
    isVisible
}) => {
    const [countryInfo, setCountryInfo] = useState<string>('Detecting...');

    useEffect(() => {
        const detectCountry = async () => {
            try {
                await geolocationService.detectGermany();
                const countryCode = geolocationService.getCountryCode();
                setCountryInfo(countryCode || 'Unknown');
            } catch (error) {
                console.warn('Failed to detect country:', error);
                setCountryInfo('Unknown');
            }
        };

        detectCountry();
    }, []);

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'absolute',
            top: '5px',
            left: '-240px',
            fontSize: '14px',
            fontFamily: 'monospace',
            // background: 'linear-gradient(135deg, #191970 0%, #4169e1 50%, #00bfff 100%)',
            background: 'linear-gradient(135deg,rgba(14, 82, 104, 0.46) 0%,rgba(14, 82, 104, 0.46) 50%,rgba(0, 191, 255, 0.46) 100%)',
            padding: '15px',
            borderRadius: '10px',
            // border: '2px solid #4169E1',
            boxShadow: '0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(65,105,225,0.3)',
            textAlign: 'left',
            minWidth: '180px',
            animation: 'debugGlow 2s ease-in-out infinite alternate'
        }}>
            <div style={{
                color: '#00BFFF',
                fontWeight: 'bold',
                marginBottom: '10px',
                textAlign: 'center',
                fontSize: '16px',
                textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
            }}>
                🔧 SPACE DEBUG
            </div>

            <div style={{
                color: '#F0F8FF',
                fontSize: '12px',
                lineHeight: '1.4'
            }}>
                <div style={{ marginBottom: '5px' }}>
                    ⚡ FPS: <span style={{ color: '#4169E1' }}>{fps.toFixed(1)}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    🏗️ Entities: <span style={{ color: '#00BFFF' }}>{entityCount}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    🚀 Level: <span style={{ color: '#9370DB' }}>{level}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    ⭐ Score: <span style={{ color: '#00BFFF' }}>{score}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    🌟 Lives: <span style={{ color: '#9370DB' }}>{lives}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    🌍 From: <span style={{ color: '#87CEEB' }}>{countryInfo}</span>
                </div>
            </div>

            <style>{`
                @keyframes debugGlow {
                    0% { box-shadow: 0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(65,105,225,0.3); }
                    100% { box-shadow: 0 8px 25px rgba(0,0,0,0.5), 0 0 25px rgba(65,105,225,0.5); }
                }
            `}</style>
        </div>
    );
};

export default DebugInfo; 